import React from "react";
import { Layout } from "antd";
import { connect } from "react-redux";
import {
	SIDE_NAV_DARK,
	SIDE_NAV_WIDTH,
	NAV_TYPE_SIDE,
	TEMPLATE,
} from "constants/ThemeConstant";
import { THEME_KEYS } from "utils/themeDisplay";
import { Scrollbars } from "react-custom-scrollbars";
import MenuContent from "./MenuContent";
import SideNavFooter from "./SideNavFooter";
import SearchInput from "./NavSearch/SearchInput";
import "./side-nav-dimo.css";

const { Sider } = Layout;

export const SideNav = ({
	navCollapsed,
	sideNavTheme,
	routeInfo,
	hideGroupTitle,
	localization = true,
	currentTheme,
}) => {
	const props = {
		sideNavTheme,
		routeInfo,
		hideGroupTitle,
		localization,
		navCollapsed,
		currentTheme,
	};

	const isLight = currentTheme === THEME_KEYS.LIGHT;
	const isQuestor = currentTheme === THEME_KEYS.QUESTOR;
	const searchTheme = isLight ? "light" : "dark";

	return (
		<Sider
			className={`side-nav side-nav--dimo ${
				isLight ? "side-nav--light" : "side-nav--dark"
			} ${sideNavTheme === SIDE_NAV_DARK ? "side-nav-dark" : ""}`}
			width={SIDE_NAV_WIDTH}
			collapsed={navCollapsed}
			style={{
				height: `calc(100vh - ${TEMPLATE.HEADER_HEIGHT}px)`,
				position: "fixed",
				top: TEMPLATE.HEADER_HEIGHT,
				boxShadow: isQuestor
					? "0 1px 8px -1px rgba(120, 53, 15, 0.35)"
					: "0 1px 4px -1px rgba(0, 0, 0, 0.12)",
				zIndex: 999,
				direction: "ltr",
				overflow: "hidden",
				display: "flex",
				flexDirection: "column",
				backgroundColor: isLight
					? "#f8f9fb"
					: isQuestor
						? "#2a1c14"
						: "#12151c",
				borderRight: isLight
					? "1px solid rgba(0, 0, 0, 0.08)"
					: isQuestor
						? "1px solid rgba(232, 119, 34, 0.28)"
						: "1px solid rgba(255, 255, 255, 0.08)",
			}}
		>
			<div className="side-nav-inner">
				{!navCollapsed ? (
					<div className="side-nav-search">
						<SearchInput
							isMobile={false}
							mode={searchTheme}
							currentTheme={searchTheme}
							variant="side"
						/>
					</div>
				) : null}
				<div className="side-nav-scroll">
					<Scrollbars autoHide style={{ height: "100%" }}>
						<MenuContent type={NAV_TYPE_SIDE} {...props} />
					</Scrollbars>
				</div>
				<SideNavFooter
					collapsed={navCollapsed}
					currentTheme={currentTheme}
				/>
			</div>
		</Sider>
	);
};

const mapStateToProps = ({ theme }) => {
	const { navCollapsed, sideNavTheme, currentTheme } = theme;
	return {
		navCollapsed,
		sideNavTheme,
		currentTheme,
	};
};

export default connect(mapStateToProps)(SideNav);
